<template>
  <v-footer class="footer" color="footer_color">
    <div class="footer_wrapper">
      <v-row class="no-gutters">
        <v-col class="footer-container-1">
          <div class="payment-methods">
            <div class="bottom-title mb-2">{{ $t(`footer.paymentMethods`) }}</div>
            <div class="d-flex flex-wrap payment-methods-icons">
<!--              <template v-for="(paymentMethod, i) in paymentMethods">-->
<!--                <img width="32" height="32" class="footer-icon" :key="i" :src="`/static/image/footer/${paymentMethod.img}.svg`" alt-->
<!--                      :contain="true" />-->
<!--                &lt;!&ndash; <v-hover v-slot="{ hover }" class="mr-3" :key="paymentMethod">-->
<!--                    <v-img max-width="67px" max-height="24px" :src="`/static/image/footer/${paymentMethod.img}.png`" alt>-->
<!--                        <v-img v-if="hover" max-width="67px" max-height="24px" :src="`/static/image/footer/${paymentMethod.img}-color.png`" alt />-->
<!--                    </v-img>-->
<!--                </v-hover> &ndash;&gt;-->
<!--              </template>-->
<!--              <img src="../../assets/svg/bottom/bkash.png" height="26" width="27"/>-->
<!--              <img src="../../assets/svg/bottom/nagad.png" height="32" width="25"/>-->
<!--              <img src="../../assets/svg/bottom/rocket.png" height="26" width="42"/>-->
<!--              <img src="../../assets/svg/bottom/upay logo.png" height="33" width="28"/>-->
              <img src="/static/svg/Bank_Icon.svg" height="26" width="26" />
<!--              <img src="/static/svg/nagad.svg" height="26" width="26" />-->
<!--              <img src="/static/svg/rocket.svg" height="26" width="26" />-->
<!--              <img src="/static/svg/upay%20logo.png" height="26" width="26" />-->
            </div>
          </div>

          <div class="d-flex flex-column follow-us">
<!--            <label class="bottom-title">{{ $t(`Follow Us`) }}</label>-->
            <div class="bottom-title mb-2">{{ $t(`label.followus`) }}</div>
            <div class="d-flex flex-wrap payment-methods-icons">
              <a href="https://t.me/nagad88official" target="_blank">
                <svg id="Group_98" href="https://t.me/nagad88official"  data-name="Group 98" xmlns="http://www.w3.org/2000/svg" width="20.587" height="20.587" viewBox="0 0 20.587 20.587">
                  <path id="Path_70" data-name="Path 70" d="M653.786,449.654a10.293,10.293,0,1,0-10.294-10.294A10.294,10.294,0,0,0,653.786,449.654Z" transform="translate(-643.492 -429.067)" fill="#a2aabd"/>
                  <path id="Path_71" data-name="Path 71" d="M649.96,442.948s5.146-2.112,6.932-2.856c.684-.3,3-1.249,3-1.249s1.071-.417.982.595c-.03.417-.267,1.875-.506,3.451-.357,2.231-.743,4.67-.743,4.67s-.06.685-.565.8a2.444,2.444,0,0,1-1.487-.536c-.119-.089-2.231-1.428-3-2.083a.563.563,0,0,1,.029-.952c1.071-.982,2.351-2.2,3.124-2.975.357-.357.714-1.19-.773-.179-2.112,1.458-4.195,2.827-4.195,2.827a1.748,1.748,0,0,1-1.368.029c-.893-.267-1.934-.624-1.934-.624s-.714-.446.506-.922Z" transform="translate(-645.675 -432.744)" fill="#fff"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/nagad88official" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="20.587" height="20.587" viewBox="0 0 20.587 20.587">
                  <path id="Path_69" data-name="Path 69" d="M173.6,429.067A10.293,10.293,0,1,0,183.9,439.36,10.293,10.293,0,0,0,173.6,429.067Zm4.052,5.2H176.45a1.381,1.381,0,0,0-1.558,1.493v1.793h2.652l-.424,2.764h-2.228V447H171.9v-6.681h-2.428v-2.764H171.9v-2.106a3.374,3.374,0,0,1,3.612-3.72,14.708,14.708,0,0,1,2.141.187Z" transform="translate(-163.31 -429.067)" fill="#a2aabd"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@nagad88official" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="20.587" height="20.587" viewBox="0 0 20.587 20.587">
                  <path id="Path_67" data-name="Path 67" d="M476.2,439.623,472.81,441.3c-.133.072-.584-.024-.584-.176v-3.44c0-.153.455-.249.588-.173l3.242,1.764C476.192,439.352,476.334,439.549,476.2,439.623Zm7.814-.263a10.293,10.293,0,1,1-10.294-10.293A10.294,10.294,0,0,1,484.011,439.36Zm-3.372-1.757a2.954,2.954,0,0,0-2.954-2.954h-7.553a2.954,2.954,0,0,0-2.954,2.954v3.515a2.954,2.954,0,0,0,2.954,2.954h7.553a2.954,2.954,0,0,0,2.954-2.954Z" transform="translate(-463.424 -429.067)" fill="#a2aabd"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/nagad88official/" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="20.587" height="20.587" viewBox="0 0 20.587 20.587">
                  <path id="Path_68" data-name="Path 68" d="M233.626,429.067a10.293,10.293,0,1,0,10.294,10.293A10.293,10.293,0,0,0,233.626,429.067Zm6.24,12.784a3.753,3.753,0,0,1-3.749,3.749h-4.982a3.753,3.753,0,0,1-3.748-3.749v-4.982a3.752,3.752,0,0,1,3.748-3.748h4.982a3.752,3.752,0,0,1,3.749,3.748Zm-4.22-2.491a1.969,1.969,0,1,1-1.968-1.968A1.971,1.971,0,0,1,235.646,439.36Zm.471-5.066h-4.982a2.577,2.577,0,0,0-2.574,2.575v4.982a2.577,2.577,0,0,0,2.574,2.575h4.982a2.577,2.577,0,0,0,2.575-2.575v-4.982A2.577,2.577,0,0,0,236.117,434.294Zm-2.439,8.139a3.073,3.073,0,1,1,3.073-3.073A3.076,3.076,0,0,1,233.677,442.433Zm3.252-5.621a.732.732,0,1,1,.732-.732A.732.732,0,0,1,236.929,436.812Z" transform="translate(-223.332 -429.067)" fill="#a2aabd"/>
                </svg>
              </a>
            </div>
      </div>

          <div class="community">
            <v-row no-gutters class="mb-2">
              <label class="bottom-title">{{ $t(`footer.certification`) }}</label>
            </v-row>
            <v-row no-gutters class="bnw_img">
<!--              <img src="../../assets/svg/bottom/gaming_Casino_Analyzer.svg.png" height="25" width="61" alt="casino analyzer"/>-->
<!--              <img src="../../assets/svg/bottom/footer-iTechLabs.svg.png" height="25" width="26" alt="gaming itech" class="ml-2"/>-->
              <img width="77" height="32" src="/static/image/footer/gaming_Casino_Analyzer.svg" @click="gotoCAPage" alt="casino analyzer"/>
              <img src="/static/svg/footer-iTechLabs.svg" height="32" width="32" alt="gaming itech" class="ml-2"/>
            </v-row>
          </div>

          <div class="follow-us">
            <div class="bottom-title mb-2">{{ $t(`footer.communityWebsite`) }}</div>
            <div class="d-flex flex-wrap payment-methods-icons">
              <template v-for="(responsbileGambling, i) in responsbileGamblingLink">
                <img width="32" height="32" :key="i" class="footer-icon bnw_img" :src="`/static/image/footer/${responsbileGambling.img}.png`"
                     alt="responsible gaming" />
                <!-- <v-hover v-slot="{ hover }" class="mr-3" :key="responsbileGambling">
                    <v-img class="footer-icon" :src="`/static/image/footer/${responsbileGambling.img}.png`" alt>
                        <v-img v-if="hover" class="footer-icon" :src="`/static/image/footer/${responsbileGambling.img}-color.png`" alt />
                    </v-img>
                </v-hover> -->
              </template>
            </div>
          </div>

          <div :class="$vuetify.breakpoint.mdAndUp ? 'gaming-license' : ''">
            <div class="bottom-title mb-2">{{ $t(`footer.gamingLicense`) }}</div>
            <div class="d-flex flex-wrap payment-methods-icons">
              <img class="bnw_img" width="99" height="32" src="/static/image/footer/gaming_license.webp" alt="gaming license"/>
            </div>
          </div>

        </v-col>
      </v-row>

      <!-- <v-col cols="12" class="py-5">
        <v-divider></v-divider>
      </v-col> 

      <v-row no-gutters class="text-left">
        <h1 style="font-size: 1.17em">{{ $t(`footer.trustedPremiumOnlineCasinoTitle`) }} </h1>
        <p id="aaa" class="seo_text">
          {{$t(`footer.trustedPremiumOnlineCasinoDesc_1`)}}<br/>
          {{$t(`footer.trustedPremiumOnlineCasinoDesc_2`)}}<br/>
        </p>
      </v-row> -->

      <footer-content></footer-content>
    
      <v-row>
        <v-col cols="12" class="my-2">
          <v-divider></v-divider>
        </v-col>
      </v-row>

        <v-row justify="space-between" class="footer-bottom" cols="12">
            <v-row no-gutters>
                <img width="150" height="40" style="align-self:end" class="footer-logo" src="static/svg/Vertical_Logo_White.svg" alt="nagad88 logo" />
                <v-divider vertical v-show="$vuetify.breakpoint.mdAndUp" class="footer-divider ml-5"></v-divider>
            </v-row>
            <v-col no-gutters cols="12" :md="4" class="faq-container">
                <v-row class="faq-wrapper" ref="faqWrapper">
<!--                    <router-link :to="{ name: routeName.APPLY_AGENT }" class="footer-title">{{$t(`label.affiliate`)}}</router-link>-->
                  <router-link :to="listItemToAGENTAPPLY" class="footer-title">{{$t(`label.affiliate`)}}</router-link>
                    <router-link :to="listItemToFAQ" class="footer-title">{{$t(`label.responbileGaming`)}}</router-link>
<!--             row   <router-link :to="{ name: routeName.TNC }" class="footer-title">{{$t(`label.tnc`)}}</router-link>-->
                    <router-link :to="listItemToABOUTUS" class="footer-title">{{$t(`label.aboutUs`)}}</router-link>
                </v-row>
              <v-row>
                <!-- <div v-show="$vuetify.breakpoint.smAndDown" class="title_color--text font-weight-bold">{{$t(`footer.bestQualityPlatform`)}}</div> -->
                <div class="copyright" style="color: var(--v-description-darken3)">{{ footerCopyRight }}</div>
              </v-row>
            </v-col>
        </v-row>
    </div>
  </v-footer>
</template>

<script>
import FooterContent from '@/components/layout/FooterContent.vue'
import NavOnePay from '@/assets/svg/onePay.svg'
import AppLanguage from '@/components/layout/Language.vue'
import {
  ROUTE_NAME
} from '@/constants/route.constants'
import format from 'string-format'
import {
  locale,
  uiHelper
} from '@/util'
import {
  SHARED,
  CACHE_KEY
} from '@/constants/constants'
import {
  SHARED_LOADING
} from '@/store/shared.module'

export default {
  name: 'appFooter',
  props: {},
  components: {
    FooterContent,
    NavOnePay
  },
  data: () => ({
    currentLanguage: uiHelper.getLanguage(),
    isViewableAll: false,
    footerProvider: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_LIST_TYPE_NAME}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    supportedLanguage: SHARED.SUPPORTED_LANGUAGES,
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    routeName: ROUTE_NAME,
    footerLink: [
      // {
      //   link: '/customer-service',
      //   text: locale.getMessage(`label.customerROUTE_NAMEService`)
      // },
      {
        routeName: ROUTE_NAME.TNC,
        text_key: 'termsAndConditions'
      },
      {
        routeName: ROUTE_NAME.ABOUT_US,
        text_key: 'aboutUs'
      },
      {
        routeName: ROUTE_NAME.FAQ,
        text_key: 'faq'
      },
      {
        routeName: ROUTE_NAME.CONTACT_US,
        text_key: 'contactUs'
      }
    ],
    socialMediaLink: [{
      name: 'facebook',
    },
      {
        name: 'instagram',
      },
      {
        name: 'twitter',
      },
      {
        name: 'youtube',
      },
      {
        name: 'pinterest',
      },
    ],
    responsbileGamblingLink: [
      {
        img: 'safe2',
      },
      {
        img: 'safe1',
      }
    ],
    paymentMethods: [{
      img: 'payment-bank',
    },
      {
        img: 'payment-bkash',
      },
      {
        img: 'payment-nagad',
      },
      {
        img: 'payment-rocket',
      }
    ],
    footerCopyRight: format(locale.getMessage(`message.copyRight`), new Date().getFullYear())
  }),
  computed: {
    listItemToAGENTAPPLY() {
      if (!this.$route.params.lang) {
        return '/profile/agent/apply';
      } else {
        return `/${this.$route.params.lang}/profile/agent/apply`;
      }
    },
    listItemToFAQ() {
      if (!this.$route.params.lang) {
        return '/info/FAQ';
      } else {
        return `/${this.$route.params.lang}/info/FAQ`;
      }
    },
    listItemToABOUTUS() {
      if (!this.$route.params.lang) {
        return '/info/about-us';
      } else {
        return `/${this.$route.params.lang}/info/about-us`;
      }
    },
    uiHelper() {
      return uiHelper
    },
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    }
  },
  watch: {
    ProviderTypes() {
      this.footerProvider = uiHelper.getLocalStorage(`${CACHE_KEY.GAME_LIST_TYPE_NAME}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`)
      return this.$store.state.game.ProviderTypes
    }
  },
  methods: {
    gotoCAPage(){
      window.open('https://casinosanalyzer.com', '_blank')
    },
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED_LOADING}`)
      locale.setCurrentLanguage(language)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    goToFirstCagayan() {
      window.open('https://www.firstcagayan.com/zh-hant#2', '_blank')
    },
    goToPagcor() {
      window.open('http://www.pagcor.ph/index.php', '_blank')
    }
  }
}
</script>

<style lang="scss">

.followUs {
  display: inline-block;
  margin: 10px; /* adds 10px margin around the image */
  background-color: transparent; /* makes the background transparent */
  opacity: 1;
  }

.v-footer {
  position: unset;

  .footer {
    //min-height: 1080px;
    padding-bottom: 12px;
  }

  .bottom-title {
    text-align: left;
    font: normal normal normal 10px/12px Proxima Nova;
    letter-spacing: 0.25px;
    color: #fff;
    opacity: 1;
  }

  .footer-title {
    //font-size: 12px;
    //font-family: "ReadexPro-Bold";
    text-align: left;
    text-decoration: underline;
    font: normal normal 600 14px/21px Poppins;
    letter-spacing: 0.14px;
    color: #0047FF;
    opacity: 1;
  }

  .footer_wrapper {
    width: 100%;
    max-width: 1240px;
    margin: 30px auto;
    font-size: 12px;

    .footer-container-1 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      row-gap: 20px;

      .column-gap {
        gap: 4px;
      }
    }
  }

  .footer-divider {
    color: var(--v-divider-base);
  }

  .footer-logo {
    width: 120px;
  }

  .footer-disabled {
    filter: grayscale(100%);
  }

  .footer-icon {
    max-width: 32px;
    max-height: 32px;
  }

  .seo_text {
    font-size: 14px;
    color: var(--v-description-darken3);
  }

  .footer-link-divider {
    border-color: #3A3A3A;
  }

  .footer-support:hover {
    color: var(--v-primary-base);
  }

  .gaming-license {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;

  }

  .payment-methods-icons {
    gap: 12px;
  }

    .faq-container {
        text-align: end;
      padding-bottom: 40px;
      //display: flex;

        .faq-wrapper {
            //gap: 12px;
            //color: var(--v-primary-base);
            //margin: 0px 0px 12px 0px;
            //justify-content: end;
          /* Layout Properties */
          top: 1897px;
          left: 19px;
          margin-top: 1px;
          margin-bottom: 1px;
          width: 300px;
          height: 20px;
          /* UI Properties */
          text-align: left;
          text-decoration: underline;
          font: normal normal 600 14px/21px Poppins;
          letter-spacing: 0.14px;
          color: #0047FF;
          opacity: 1;
          justify-content: space-between;
        }
    }


}

@media (max-width: 599px) {

  .footer {
    margin-bottom: 50px;


    .footer_wrapper {

      .footer-container-1 {

        .follow-us {
          width: 50%;
        }

        .community {
          width: calc(50% - 10px);
        }

        .payment-methods {
          width: calc(45% - 10px);
        }

                .payment-methods-icons {
                    gap: 20px;
                }
            }

            .faq-container {
                text-align: start;

                //.faq-wrapper {
                //    justify-content: space-between;
                //}
            }
        }
    }
}

.footer-bottom{
  display: flex;
  align-items: center;
  padding: 1rem;
}

.bnw_img{
  filter: grayscale(100%);
}
</style>
